import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=b33b8884&scoped=true&"
import script from "./EventDetail.vue?vue&type=script&lang=ts&"
export * from "./EventDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=b33b8884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33b8884",
  null
  
)

export default component.exports